import { CloudStore } from "@omni/types/api/store/cloud/store.model";

export const $StoreDetailsModuleName = "storeDetails";

export type TStoreDetailsState = CloudStore;
